var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHandBye = function SvgHandBye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.01 6.26 2.16 2.08M3.24 3.64l3.41 3.28M4.72 2.22l3.4 3.27M12.11 2.09c-.64.09-1.1.69-1.01 1.34l.06.42c.11.75.29 2.1.29 2.1l-.64-.64L9.5 4 6.19.79a1.07 1.07 0 0 0-1.47 0 .99.99 0 0 0 0 1.42L4 1.52a1.07 1.07 0 0 0-1.47 0 .99.99 0 0 0 0 1.42l.72.69a1.07 1.07 0 0 0-1.47 0 .99.99 0 0 0 0 1.42l1.24 1.19a1.07 1.07 0 0 0-1.47 0 .99.99 0 0 0 0 1.42l4.46 4.31s.05.03.07.05c.04.04.07.09.11.12 1.85 1.78 4.84 1.78 6.69 0a4.462 4.462 0 0 0 1.31-3.95l-.72-5.12c0-.06-.04-.11-.06-.17v-.07s-.04-.05-.06-.08c-.03-.07-.07-.14-.11-.2a.426.426 0 0 0-.11-.12c-.25-.26-.61-.41-1-.36l-.02.02Z",
    stroke: "#616161",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHandBye;